import { Action, createReducer, on } from '@ngrx/store';
import { IMassiveUploadState, IUploadFileResult } from './massive-upload';
import {
  RESET_MASSIVE_UPLOADS_STORE,
  UPLOAD_FILE_MASSIVE_DATA_SUCCESS,
  UPLOAD_FILE_MASSIVE_SUCCESS,
} from './massive-upload.actions';
import { GenericResponse } from '../../interfaces/generic-response';

/* INITIAL STATE */
const initialState: IMassiveUploadState = {
  uploadFileResult: null,
  uploadFileDataResult: null,
};

const handleSaveUploadFileMassive = (
  state: IMassiveUploadState,
  { uploadFileResult }: { uploadFileResult: IUploadFileResult | null }
): IMassiveUploadState => {
  return {
    ...state,
    uploadFileResult,
  };
};

const handleSaveUploadFileMassiveData = (
  state: IMassiveUploadState,
  { uploadFileDataResult }: { uploadFileDataResult: GenericResponse | null }
): IMassiveUploadState => {
  return {
    ...state,
    uploadFileDataResult,
  };
};

const handleResetMassiveStore = (): IMassiveUploadState => {
  return {
    uploadFileResult: null,
    uploadFileDataResult: null,
  };
};

/* REDUCER */
export const reducer = createReducer(
  initialState,
  on(UPLOAD_FILE_MASSIVE_SUCCESS, handleSaveUploadFileMassive),
  on(UPLOAD_FILE_MASSIVE_DATA_SUCCESS, handleSaveUploadFileMassiveData),
  on(RESET_MASSIVE_UPLOADS_STORE, handleResetMassiveStore)
);

export const massiveUploadReducer = (
  state: IMassiveUploadState | undefined,
  action: Action
): IMassiveUploadState => reducer(state, action);
